import { NavLink, useLocation } from "react-router-dom";

import { Badge } from "reactstrap";
import ImageWrapper from "@components/ui-components/image-wrapper";
import LongNameFormatter from "@components/formatters/long-name-formatter";
import classnames from "classnames";
import size from "lodash/size";
import { useTranslation } from "react-i18next";
import CustomTooltip from "@src/@core/components/ui-components/tooltip";

const NavMenuLink = ({ item, activeItem, menuCollapsed }) => {
    // ** Conditional Link Tag, if item has newTab or externalLink props use <a> tag else use NavLink
    const LinkTag = item.externalLink ? "a" : NavLink;
    const location = useLocation();

    const isActive = () => {
        const { pathname, search } = location;
        if (item.navLink) {
            const [itemPathname, itemSearch] = item.navLink.split("?");
            if (pathname === itemPathname) {
                if (itemSearch) {
                    return search?.includes(`${itemSearch}`);
                }
                return true;
            }
            if (pathname?.includes(itemPathname)) {
                return itemSearch ? search === `?${itemSearch}` : true;
            }
        }
        return false;
    };

    // ** Hooks
    const { t } = useTranslation();

    return (
        <>
            <li
                id={`nav-${item.id}`}
                className={classnames({
                    "nav-item": !item.children,
                    disabled  : item.disabled,
                    active    : item.navLink === activeItem
                })}>
                <LinkTag
                    // className="d-flex align-items-center"
                    target={item.newTab ? "_blank" : undefined}
                    to={item.navLink || "/"}
                    className={classnames("d-flex align-items-center", {
                        active: isActive() && !item.disabled
                    })}
                    /*eslint-disable */
                    {...(item.externalLink === true
                        ? {
                            href: item.navLink || "/"
                        }
                        : {
                            to: item.navLink || "/",
                            className: () => {
                                return classnames("d-flex align-items-center", {
                                    active: isActive() && !item.disabled
                                });
                            }
                        })}
                    onClick={e => {
                        if (
                            size(item.navLink) === 0 ||
                            item.navLink === "#" ||
                            item.disabled === true
                        ) {
                            item.onClick();
                            e.preventDefault();
                        }
                    }}>
                    {item.icon && (
                        <>
                            <ImageWrapper
                                className="nav-left-icon"
                                id={item.icon}
                                src={`sidebar-icons/${item.icon}.svg`}
                            />

                        </>
                    )}

                    <LongNameFormatter
                        content={t(item.title)}
                        testId={`menu-link-${item.id}`}
                        max={25}
                        tag="span"
                        className="menu-item text-truncate"
                    />
                    {item.badge && item.badgeText ? (
                        <Badge className="ms-auto" pill color={"success"}>
                            {item.badgeText}
                        </Badge>
                    ) : null}
                    {item.accountLink && (
                        <ImageWrapper
                            className="nav-right-icon ms-75"
                            id="new-module"
                            src={`sidebar-icons/new-module.svg`}
                        />
                    )}
                </LinkTag>
            </li>
            {menuCollapsed && <CustomTooltip target={item.id} content={t(item.title)} />}
        </>
    );
};

export default NavMenuLink;
